module.exports = __webpack_public_path__ + "images/xgwfc.3f1d.png";